import styled from 'styled-components';
import { Text } from '@cuemath/web-comps';

export const AnnotationListWrapper = styled.div`
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const AnnotationItem = styled.div`
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #f5f5f5;
  border: 1px solid #c4c4c4;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  position: relative;
  overflow: hidden;
  word-wrap: break-word;
  overflow-wrap: break-word;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3px;
    height: 100%;
    background: #808080;
    transition: all 0.2s ease;
  }

  &:hover {
    background: #e8e8e8;
    border-color: #9a9a9a;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
    transform: translateX(2px);

    &::before {
      width: 4px;
      background: #5a5a5a;
    }
  }

  ${props =>
    props.isNewlyCreated &&
    `
    animation: pulse 2s ease-in-out;
    background: #d4d4d4;
    border-color: #5a5a5a;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    
    &::before {
      background: #1a1a1a;
      width: 4px;
    }
  `}

  @keyframes pulse {
    0%,
    100% {
      transform: translateX(2px);
    }
    50% {
      transform: translateX(4px);
    }
  }
`;

export const AnnotationHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`;

export const AnnotationInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Avatar = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #5a5a5a;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
  border: 2px solid #c4c4c4;
`;

export const Badge = styled.span`
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
  background: #e8e8e8;
  color: #1a1a1a;
  border: 1px solid #c4c4c4;
`;

export const EmotionIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  background: #e8e8e8;
  color: #5a5a5a;
  border: 1px solid #c4c4c4;

  svg {
    width: 14px;
    height: 14px;
    stroke-width: 2.5;
  }
`;

export const TimeStamp = styled.span`
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  font-size: 9px;
  font-weight: 500;
  color: #5a5a5a;
  background: #e8e8e8;
  padding: 2px 6px;
  border-radius: 10px;
  border: 1px solid #c4c4c4;
  transition: all 0.2s ease;
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: 8px;
`;

export const ActionButton = styled.button`
  padding: 6px 10px;
  font-size: 14px;
  min-width: auto;
  height: 32px;
  background: #f0f0f0;
  color: #2b2b2b;
  border: 1px solid #c4c4c4;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #d4d4d4;
    border-color: #9a9a9a;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  &:active {
    background: #b8b8b8;
  }
`;

export const AnnotationContent = styled(Text)`
  font-size: 13px;
  line-height: 1.5;
  margin: 0;
  margin-top: 8px;
  color: #2b2b2b;
  word-wrap: break-word;
  overflow-wrap: break-word;
  font-weight: 400;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 24px;
  color: #5a5a5a;
  background: #f0f0f0;
  border-radius: 8px;
  border: 1px solid #c4c4c4;
  margin: 0;
`;
